import axios from '@/utils/request'

export default {
  // 2020-08-14
  insertBatch(params) {
    return axios.post('/inquiries/insert-batch', params);
  },
  // 2020-08-31
  search(params) {
    return axios.get('/inquiries', params);
  },

  // 2020-09-01
  findItemsById(id) {
    return axios.get('/inquiries/' + id + '/items');
  },
  // 2020-09-01
  quote(id, itemId, params) {
    return axios.put('/inquiries/' + id + '/items/' + itemId + '/quote', params);
  },
  // 2020-09-01  我的报价查看页面
  findById(id) {
    return axios.get('/inquiries/' + id);
  },
  // 2020-12-30 客户报价查看页面
  findByIdCustomer(id) {
    return axios.get('/inquiries/' + id + '/customer');
  },

  // // 02-15
  // create(params) {
  //   return axios.post('/inquiries', params);
  // },
  // 2020-09-01
  update(id, params) {
    return axios.put('/inquiries/' + id, params);
  },
  // 2020-09-01
  delete(id) {
    return axios.delete('/inquiries/' + id);
  },
  // count() {
  //   return axios.get('/inquiries/count');
  // }
}

